// @flow
import React, { Component } from "react";

import UserAuth from "../../global/containers/UserAuth";
import RedirectoLogin from "../views/RedirectoLogin";
import MyLicence from "../containers/licences/MyLicence";

class Licence extends Component<*> {
  render(): * {
    return (
      <UserAuth principal="user" unAuthChildren={<RedirectoLogin />}>
        <div className="app-main">
          <MyLicence />
        </div>
      </UserAuth>
    );
  }
}

export default Licence;
